<template>
  <div>
    <v-card>
      <v-row>
        <v-col md-3>
          <v-row md-12>
            <v-col md-3>
              <v-img
                width="300px"
                class="mx-5 mt-7"
                src="https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Certification/PNG%203.png?updatedAt=1691473277301"
              >
                <template v-slot:placeholder>
                  <div class="d-flex align-center justify-center fill-height">
                    <v-progress-circular
                      color="grey-lighten-4"
                      indeterminate
                    ></v-progress-circular>
                  </div>
                </template>
              </v-img>
            </v-col>
            <v-col md-3>
              <v-img
                width="300px"
                class="mt-12 mx-5 mb-15"
                src="https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Certification/PNG%202.png?updatedAt=1691473277288"
              >
                <template v-slot:placeholder>
                  <div class="d-flex align-center justify-center fill-height">
                    <v-progress-circular
                      color="grey-lighten-4"
                      indeterminate
                    ></v-progress-circular>
                  </div>
                </template>
              </v-img>
            </v-col>
          </v-row>
        </v-col>
        <v-col md-3>
          <v-row md-12>
            <v-col md-3>
              <v-img
                width="300px"
                class="mx-5 mt-10"
                src="https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Certification/PNG%204.png?updatedAt=1691473277330"
              >
                <template v-slot:placeholder>
                  <div class="d-flex align-center justify-center fill-height">
                    <v-progress-circular
                      color="grey-lighten-4"
                      indeterminate
                    ></v-progress-circular>
                  </div>
                </template>
              </v-img>
            </v-col>
            <v-col md-3>
              
            </v-col>
          </v-row>
        </v-col>
        <v-col md-3>
          <v-row md-12>
            <v-col md-3>
              <v-img
                width="300px"
                class="c1"
                src="https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Certification/PNG%205.png?updatedAt=1691473277346"
              >
                <template v-slot:placeholder>
                  <div class="d-flex align-center justify-center fill-height">
                    <v-progress-circular
                      color="grey-lighten-4"
                      indeterminate
                    ></v-progress-circular>
                  </div>
                </template>
              </v-img>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {};
</script>

<style>
.c11 {
  position: absolute;
  width: 275px;
  height: 96px;
  left: 176px;
  top: 3527px;
}
</style>
